import { type GenericListQueryKey, generateListQueryKey } from '@pba/react-query';
import { calendarFeatureKey } from '../key';
import type { CalendarPrincipalEventsQueryFilter } from './types';

const localKey = ['calendarPrincipalEvents'] as const;

type CalendarPrincipalEventsListQueryType = GenericListQueryKey<Partial<CalendarPrincipalEventsQueryFilter>>;

export const getCalendarPrincipalEventsListQueryKey = (params: CalendarPrincipalEventsListQueryType) =>
  generateListQueryKey({
    prefix: [...calendarFeatureKey, ...localKey],
  })(params);
